import { useEffect, useRef, useState } from 'react';

import AlertIcon from '../../../../assets/icons/General/alert-circle.svg?react';
import CloseIcon from '../../../../assets/icons/General/close.svg?react';
import Alert from '../../../widgets/Alert';
import { CircleInfoIcon } from '../../../../assets/icons/CircleInfo';
import { Typography } from '../../../widgets/Typography';
import { CrossIcon } from '../../../../assets/icons/Cross';

interface ChartDataAlertProps {
  show: boolean;
  title: string;
  subTitle: string;
}

function ChartDataAlert({ show, title, subTitle }: ChartDataAlertProps) {
  const [visible, setVisible] = useState(show);
  const [mounted, setMounted] = useState(show);

  // Visibility handler for the alert with unmount
  useEffect(() => {
    setVisible(show);
    if (show) setMounted(true);
    else setTimeout(() => setMounted(false), 500);
  }, [show]);

  if (!mounted || !visible) return null;

  //TODO: migrate to Alert component
  return (
    <div className="bg-red-25 relative mx-6 flex flex-row gap-3 rounded-2xl border border-red-100 p-4">
      <CircleInfoIcon className="h-lh text-red-600" />
      <div className="flex flex-col gap-1">
        <Typography variant="body-sm" weight="medium" className="text-red-600">
          {title}
        </Typography>
        <Typography variant="body-sm" className="text-red-600">
          {subTitle}
        </Typography>
      </div>
      <button
        onClick={() => setVisible(false)}
        className="absolute top-4 right-4"
      >
        <CrossIcon />
      </button>
    </div>
  );
}

export default ChartDataAlert;
